import { useState } from "react";

import overviewIconWhite from "../assets/icons/invest_overview_white.svg";
import overviewIconGrey from "../assets/icons/invest_overview_grey.svg";
import exploreIconGrey from "../assets/icons/explore_products_grey.svg";
import exploreIconWhite from "../assets/icons/explore_producst_white.svg";
import { InvestSummary } from "./InvestSummary";
import InvestAvailable from "./InvestAvailable";
import InvestExplore from "./InvestExplore";
import InvestWithdrawDepositComplete from "./InvestWithdrawDepositComplete";
import { useAuth } from "../context/AuthContext";
import { useQueryUserBalance } from "../hooks/query/queries";
import Toaster from "../components/ui/toaster";

const InvestDashboardContent = () => {
  // const { user } = useUser();
  // const authId = user?.sub || "";
  // const { balance, isLoading: loading } = useQueryUserBalance(authId);
  const [tab, setTab] = useState("overview");
  const [dashType, setDashType] = useState("invest");
  const { user, userProfile } = useAuth();
  const authId = user?.sub || "";
  const userId = userProfile?._id;

  const { balance, isLoading: loading } = useQueryUserBalance(authId);

  function changeToggle(data) {
    setTab(data);
  }

  return (
    <main>
      <Toaster />
      <InvestSummary dashType={dashType} product={null} userId={userId} />

      <div className="px-20  py-7 bg-bg-light-gray rounded-t-2xl space-y-8 -translate-y-4 min-h-96">
        <div className="grid grid-cols-5 gap-4">
          <div className="flex flex-col px-6">
            <div
              className={
                tab == "overview"
                  ? "flex bg-gradient-to-r from-pink-500 to-purple-500 pl-6 py-4 mb-3 rounded-full hover:cursor-pointer"
                  : "flex pl-6 py-4 mb-3 rounded-full hover:cursor-pointer"
              }
              onClick={() => changeToggle("overview")}
            >
              <img
                src={tab == "overview" ? overviewIconWhite : overviewIconGrey}
                alt=""
                className="mr-3"
              />
              <p
                className={
                  tab == "overview"
                    ? "text-white text-[14px] hover:cursor-pointer"
                    : "text-text-secondary text-[14px] hover:cursor-pointer"
                }
              >
                Overview
              </p>
            </div>
            <div
              className={
                tab == "explore"
                  ? "flex bg-gradient-to-r from-pink-500 to-purple-500 pl-6 py-4 mb-3 rounded-full hover:cursor-pointer"
                  : "flex pl-6 py-4 mb-3 rounded-full hover:cursor-pointer"
              }
              onClick={() => changeToggle("explore")}
            >
              <img
                src={tab == "explore" ? exploreIconWhite : exploreIconGrey}
                alt=""
                className="mr-3"
              />
              <p
                className={
                  tab == "explore"
                    ? "text-white text-[14px]"
                    : "text-text-secondary text-[14px]"
                }
              >
                Explore products
              </p>
            </div>
          </div>
          {(() => {
            if (tab == "overview") {
              return <InvestAvailable userId={userId} />;
            } else {
              return <InvestExplore userId={userId} />;
            }
          })()}
        </div>
      </div>
    </main>
  );
};

export default InvestDashboardContent;
